import {
  useActiveRenderConfigShallow,
  useActiveRenderScope,
} from "../app/renderConfig.ts";
import { resolveAmbientFill } from "./renderCalibration.ts";

/**
 * Renders the ambient light for material/PBR mode.
 * Per-object lights (point, directional) are now scene objects
 * rendered by PrimitiveRenderer.
 */
export function SceneLights() {
  const scope = useActiveRenderScope();
  const { viewMode, envMapEnabled, ambientColor, ambientIntensity } =
    useActiveRenderConfigShallow((c) => ({
      viewMode: c.viewMode,
      envMapEnabled: c.envMapEnabled,
      ambientColor: c.ambientColor,
      ambientIntensity: c.ambientIntensity,
    }));

  const ambient = resolveAmbientFill({
    scope,
    viewMode,
    envMapEnabled,
    ambientColor,
    ambientIntensity,
  });

  if (!ambient) return null;

  return <ambientLight intensity={ambient.intensity} color={ambient.color} />;
}
